// {
//   "name": "iconic-product-specifications.js",
//   "author": "Arham Web Works",
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(() => {
  if (customElements.get('iconic-product-specifications')) {
    return;
  }

  class IconicProductSpecifications extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const section = this;
      if (section.dataset.specInitialized === "true") return;
      section.dataset.specInitialized = "true";

      const allRows = Array.from(section.querySelectorAll("[data-row-kind]"));
      const showMoreBtn = section.querySelector("[data-show-all-btn]");
      const initialRows = parseInt(section.dataset.initialRows || "10", 10);
      let expanded = false;

      function updateRows() {
        const specRows = allRows.filter((row) => row.getAttribute("data-row-kind") === "spec");
        const headingRows = allRows.filter((row) => row.getAttribute("data-row-kind") === "heading");

        specRows.forEach((row, index) => {
          if (!expanded && index >= initialRows) {
            row.classList.add("iconic-d-none");
          } else {
            row.classList.remove("iconic-d-none");
          }
        });

        headingRows.forEach((heading) => {
          let hasVisibleSpecUnderHeading = false;
          let cursor = heading.nextElementSibling;

          while (cursor) {
            const kind = cursor.getAttribute("data-row-kind");
            if (kind === "heading") break;
            if (kind === "spec" && !cursor.classList.contains("iconic-d-none")) {
              hasVisibleSpecUnderHeading = true;
              break;
            }
            cursor = cursor.nextElementSibling;
          }

          heading.classList.toggle("iconic-d-none", !hasVisibleSpecUnderHeading);
        });

        if (!showMoreBtn) return;

        if (specRows.length <= initialRows) {
          showMoreBtn.classList.add("iconic-d-none");
          return;
        }

        showMoreBtn.classList.remove("iconic-d-none");
        if (expanded) {
          showMoreBtn.textContent = "Show Less";
        } else {
          showMoreBtn.textContent = `Show All (${specRows.length} rows)`;
        }
      }

      if (showMoreBtn) {
        showMoreBtn.addEventListener("click", (event) => {
          event.preventDefault();
          expanded = !expanded;
          updateRows();
        });
      }

      updateRows();
      section.style.display = '';
    }
  }

  customElements.define('iconic-product-specifications', IconicProductSpecifications);
})();